<template>
  <div class="budget">
    <div class="main">
      <div class="title_bar">
        <div class="title">
          長期修繕金額預估
        </div>
      </div>
      <div class="overview">
        <div class="communityName-time-container">
          <div class="communityName-time-wrapper">
            <div class="title">
              社區名稱：
            </div>
            <div class="content">
              {{ communityName }}
            </div>
          </div>
          <div class="communityName-time-wrapper">
            <div class="title">
              預估時間：
            </div>
            <div class="content">
              {{ selectedYears }} 年
            </div>
          </div>
        </div>

        <table>
          <tr>
            <td>更換費用</td>
            <td>{{ budget.ReplacementCost }}</td>
          </tr>
          <tr>
            <td>維養費用</td>
            <td>{{ budget.MaintenanceCost }}</td>
          </tr>
          <tr>
            <td>總計</td>
            <td>{{ budget.TotalCost }}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="main">
      <div class="title_bar">
        <div class="title">
          詳細資訊
        </div>
      </div>
      <el-tabs
        id="AssetTab"
        v-model="activeName"
        :before-leave="checkTab"
      >
        <el-tab-pane name="changeBudget">
          <span slot="label">更換費用</span>
        </el-tab-pane>
        <el-tab-pane name="maintenanceBudget">
          <span slot="label">維養費用</span>
        </el-tab-pane>
      </el-tabs>
      <router-view ref="view" />
      <div class="button-container">
        <el-button
          type="primary"
          @click="backToMaintenance"
        >
          返回維養計畫列表
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    console.log('this.$route', this.$route.params.selectedYears)
    const loginUserInfo = JSON.parse(localStorage.getItem('loginUserInfo'))
    const communityName = loginUserInfo.CommunityName
    const budget = {
      ReplacementCost: 0,
      MaintenanceCost: 0,
      TotalCost: 0
    }
    return {
      activeName: this.$route.name,
      selectedYears: this.$route.params.selectedYears,
      communityName,
      budget
    }
  },
  watch: {
    $route (to, from) {
      this.activeName = to.name
      if (this.selectedYears !== to.params.selectedYears) {
        this.selectedYears = to.params.selectedYears
        this.getBudget()
      }
    }
  },
  mounted () {
    this.getBudget()
  },
  methods: {
    checkTab (activeName, oldActiveName) {
      if (activeName !== oldActiveName) {
        this.$router.push({ name: activeName })
      }
    },
    backToMaintenance () {
      this.$router.push({
        name: 'maintenance'
      })
    },
    async getBudget () {
      try {
        const { data } = await apiAsset.maintenance.getCostEstimation(this.selectedYears)
        this.budget = data
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="scss">
.budget {
  @include mainLayer();
  .main {
    margin-top: 30px;
    &:first-of-type {
      margin-top: 0;
    }
    .button-container {
      padding-top: 20px;
    }
  }
  .overview {
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 20px;
    .communityName-time-container {
      display: flex;
      flex-direction: column;
      gap: 10px;
      .communityName-time-wrapper {
        display: flex;
      }
    }
    table {
      border-collapse: collapse;
      border: 1px solid $borderDark4;
      th,
      tr,
      td {
        border: 1px solid $borderDark4;
        text-align: start;
        padding: 5px 10px;
      }
      tr {
        td:first-of-type {
          width: 200px;
        }
        td:nth-child(2) {
          width: 100px;
        }
      }
    }
  }
}
</style>
